// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const lapras: PokeData = {
  "id": 131,
  "name": "lapras",
  "height": 25,
  "weight": 2200,
  "base_experience": 187,
  "types": [
    PokeType.WATER,
    PokeType.ICE
  ],
  "api_moves": [
    "body-slam",
    "growl",
    "sing",
    "mist",
    "water-gun",
    "hydro-pump",
    "surf",
    "ice-beam",
    "blizzard",
    "confuse-ray",
    "perish-song",
    "safeguard",
    "rain-dance",
    "sheer-cold",
    "water-pulse",
    "brine",
    "dragon-pulse",
    "ice-shard",
    "life-dew"
  ],
  "moves": [
    "body-slam",
    "growl",
    "hydro-pump",
    "blizzard",
    "confuse-ray",
    "rain-dance",
    "sheer-cold",
    "brine",
    "dragon-pulse",
    "ice-shard",
    "life-dew",
    "avalanche",
    "chilly-reception"
  ],
  "evolution_chain": {
    "id": 65,
    "item": null,
    "species": [
      {
        "name": "lapras",
        "order": 155,
        "types": [
          PokeType.WATER,
          PokeType.ICE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 171,
    "speed": 95,
    "ability_power": 134
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
